module.exports = __webpack_public_path__ + "static/media/salted-caramel-deluxe.3e3c624e.png";